import React, { useEffect } from "react";
import { DESIGNER_PAGE, MAIN_PAGE } from "../../redux_store/appState";
import { NEW_JOB } from "../../redux_store/jobState";

function usePageLayout({ page, dispatch, ClosePaper }) {
    useEffect(() => {
        if (page === DESIGNER_PAGE) {
            document.documentElement.style.overflow = "hidden";
            document.documentElement.style.scrollbarGutter = "unset";
        }

        if (page === MAIN_PAGE) {
            document.documentElement.style.overflow = "auto";
            document.documentElement.style.scrollbarGutter = "stable";
            ClosePaper();
            dispatch({
                type: NEW_JOB,
                parameter: null,
            });
        }
    }, [page]);
}

export default usePageLayout;
